export const patternMatch = {
    SSN: /^[0-9]{9,9}$/,
    name: /^(?=.{2,30}$)[A-Za-z]+([-' ][A-Za-z]+)*\s*$/,
    formattedSSN: /^\d{3}-\d{2}-\d{4}$/,
    ssnOrItinPartial: /^(\d{4,9}|\d{3}-\d{2}-\d{4}|\*?\d*\*?)$/,
    number : /[^0-9/]/g,
    onlyNumber: /^[0-9]+$/,
    passCode : /^(?:\d{1,4})(?:\.\d{1,2})?$/, 
    examCode : /^[A-Za-z0-9\s-]{3,10}$/,
    examName :  /^[A-Za-z\s.,\-&'()/]{2,60}$/,
    date : /^((0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(\d{4})|(0[1-9]|1[0-2])\/\d{4}|\d{4}|\*[\w\d\/]*|[\w\d\/]*\*)$/,
    email: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
    /** Same as registration-form primary/recovery email (requires domain + dot + TLD). */
    registrationEmail: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,10}$/,
    email10: /^([\w-.]+@([\w-]+\.)+[\w-]{2,10}|\*[\w\-@.]*|[\w\-@.]*\*)$/,
    ssn4digits : /^\d{4}$/,
    phoneNumber: /^[0-9]{10}$/,
    tcnNumber: /^[A-Za-z0-9]{5,}$/
};

/**
 * Lookup name-change / prior-name fields — must stay in sync with
 * registration-form.component.ts firstName and lastName Validators.pattern (do not change one without the other).
 */
export const legalNameFirstLastPattern = /^[A-Za-z]+([-' ][A-Za-z]+)*\s*$/;

/**
 * Must stay in sync with registration-form.component.ts middleName Validators.pattern.
 */
export const legalNameMiddleOptionalPattern = /^[A-Za-z]*([-' ][A-Za-z]+)*\s*$/;